import { AuthList, ExemptionSpec, IEmployeeSummary } from '../types/Employee'
import { AuthTypes, CampusAuthTypes } from '../types/BaseType'
import { PlanTabs } from '../types/PlanTabs'

class AuthUtil {
  getEmployeeSummary(): IEmployeeSummary | null {
    let item = localStorage.getItem('employee')
    if (item !== null) {
      return JSON.parse(item) as IEmployeeSummary
    }
    return null
  }

  getEmployeeExemption(): ExemptionSpec[] {
    let employee: IEmployeeSummary | null = this.getEmployeeSummary()
    if (employee !== null) {
      return employee.exemptionSpecList as ExemptionSpec[]
    }
    return [] as ExemptionSpec[]
  }

  getEmployeeExemptionOf(employee: IEmployeeSummary): ExemptionSpec[] {
    if (employee !== null) {
      return employee.exemptionSpecList as ExemptionSpec[]
    }
    return [] as ExemptionSpec[]
  }

  hasRemote(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions.map((exemption) => exemption.code).includes(AuthTypes.REMOTE.valueOf())
  }

  hasOffice(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(AuthTypes.OFFICE.valueOf())
  }

  hasCommon(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(AuthTypes.COMMON.valueOf())
  }

  hasAny(exemptions: ExemptionSpec[], authType: AuthTypes): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(authType.valueOf())
  }

  /* Campus services related */
  hasCampus(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(AuthTypes.CAMPUS.valueOf())
  }
  hasHealth(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(CampusAuthTypes.HEALTH.valueOf())
  }
  hasGym(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(CampusAuthTypes.GYM.valueOf())
  }
  hasCoiffeur(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(CampusAuthTypes.COIFFEUR.valueOf())
  }
  hasLactation(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(CampusAuthTypes.LACTATION.valueOf())
  }
  hasParkArea(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(CampusAuthTypes.PARK.valueOf())
  }
  hasMeeting(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(CampusAuthTypes.MEETING.valueOf())
  }
  hasPoolVehicle(exemptions: ExemptionSpec[]): boolean {
    if (exemptions === null || exemptions === undefined || exemptions.length === 0) return true
    return !exemptions?.map((exemption) => exemption.code).includes(CampusAuthTypes.POOL.valueOf())
  }

  getPlanTabsAuthorized(exemptions: ExemptionSpec[]): PlanTabs[] {
    let haveTabs: PlanTabs[] = []

    if (this.hasRemote(exemptions)) haveTabs.push(PlanTabs.AWAY)
    if (this.hasOffice(exemptions)) haveTabs.push(PlanTabs.OFFICE)
    if (this.hasCommon(exemptions)) haveTabs.push(PlanTabs.COMMON)
    return haveTabs
  }

  isLoggedIn(): boolean {
    let token = localStorage.getItem('token')
    return token !== null
  }

  getAuthListOf(employee: IEmployeeSummary): AuthList[] {
    return employee.authList
  }

  isAdmin(authList: AuthList[] | undefined): boolean {
    if (authList === undefined) return false
    return authList?.map((auth) => auth.action).includes('RedirectAdminUrl')
  }

  isSecurity(authList: AuthList[] | undefined): boolean {
    if (authList === undefined) return false
    return authList?.map((auth) => auth.action).includes('SecurityPage')
  }
  isSecurityFirmRes(authList: AuthList[] | undefined): boolean {
    if (authList === undefined) return false
    return authList?.map((auth) => auth.action).includes('GetSecurityFirmReservations')
  }
  canSeeDashboard(authList: AuthList[] | undefined): boolean {
    if (authList === undefined) return false
    return authList?.map((auth) => auth.controller).includes('Dashboard')
  }
}

export default new AuthUtil()
